import { parsePastedDate } from '@asamco/utils';
import DevExpress from 'devextreme';

/** default settings for DX date box */
export const dxDateBoxDefaults: DevExpress.ui.dxDateBoxOptions = {
	displayFormat: 'dd/MM/yyyy',
	useMaskBehavior: true,
	onPaste: (e: any) => {
		const clipboardData = e.event?.clipboardData || e.event?.originalEvent?.clipboardData || (window as any).clipboardData;

		if(clipboardData) {
			const txt: string = clipboardData.getData('text');
			const date: Date = parsePastedDate(txt);
			if (date) {
				e.event.preventDefault();
				e.component.option('value', date);
			}
		}
	},
};
